import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { Button } from '@newComponents/Button/Button'
import { PresentationCard } from '@newComponents/Presentation/PresentationCard'

import { GuildPresentationsScreenUpcomingPresentationsSection_guild$key } from './__generated__/GuildPresentationsScreenUpcomingPresentationsSection_guild.graphql'

export const GuildPresentationsScreenUpcomingPresentationsSection = ({
  guild,
}: {
  guild: GuildPresentationsScreenUpcomingPresentationsSection_guild$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildPresentationsScreenUpcomingPresentationsSection_guild on Guild
      @refetchable(
        queryName: "GuildPresentationsScreenUpcomingPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingPresentations: presentationsByEventTimeSelection(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "GuildPresentationsScreenUpcomingPresentationsSection_guild_upcomingPresentations"
          ) {
          edges {
            node {
              ...PresentationCardNew_presentation
            }

            cursor
          }
        }
      }
    `,
    guild
  )

  if (data.upcomingPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'>Upcoming Presentations</Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      {data.upcomingPresentations.edges.map((edge) => {
        return (
          <PresentationCard
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      {hasNext && (
        <Button
          secondary
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Button.Text secondary>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Button.Text>
        </Button>
      )}
    </YStack>
  )
}
